module.exports = __webpack_public_path__ + "images/bug_dark_green_size_6_2729422f6ac6a04be3d0d8e38bb3fc58.png";